<div class="subscription-dialog" data-testid="sub-required-container">

  <h1 ev-dialog-title>
    {{ languageService.languageJSON.SubscriptionsDialog_Packages }}
  </h1>
  <div ev-dialog-content>
    <div class="logo">
      <img src="assets/icons/dark/logo/ev_navigation_logo.png" alt="evnavigation" />
      <img id="proplus-icon" src="assets/icons/default/ui/pro_proplus_logo.svg" alt="plus" />
    </div>
    <div class="content">
      <p data-testid="sub-required-feature-text" [innerHTML]="featureInfo"></p>
      @if (!accountService.getIsAuthorized()) {
        <p
        [innerHtml]="languageService.languageJSON.SubscriptionsDialog_CreateUserActivatePROAndPROPackage"></p>
      }
      @if (accountService.getIsAuthorized()) {
        <p
        [innerHtml]="languageService.languageJSON.SubscriptionsDialog_ActivatePROAndPROPackage"></p>
      }

      @if (!accountService.getIsAuthorized()) {
        <p><a data-testid="sub-required-login-link" (click)="login()">{{
        languageService.languageJSON.SubscriptionsDialog_IAlreadyHaveAnAccount }}</a></p>
      }
    </div>

  </div>
  <div ev-dialog-actions>
    @if (!accountService.getIsAuthorized()) {
      <button class="ev-button primary" mat-button data-testid="sub-required-register-btn" (click)="register()">{{
      languageService.languageJSON.AccountDialog_Register }}</button>
    }
    @if (accountService.getIsAuthorized()) {
      <button class="ev-button primary" mat-button data-testid="sub-required-activate-btn" (click)="activate()">{{
      languageService.languageJSON.SubscriptionsDialog_Activate }}</button>
    }
    <button class="ev-button" mat-button data-testid="sub-required-cancel-btn" (click)="close()">{{ languageService.languageJSON.Global_Cancel }}</button>
  </div>

</div>